import { colors, radius, spacing } from '@lamimed/pantheon';
import styled, { css } from 'styled-components';

import { ContentBoxProps, FooterProps, TitleProps } from '.';

export const ContentBoxWrapper = styled.div<ContentBoxProps>`
  ${({
    marginBottom = 'medium',
    verticalAlignment = 'start',
    horizontalAligment = 'start',
    padding = spacing.medium,
    height,
    expanded,
  }) => css`
    display: flex;
    flex-direction: column;
    flex: 1;

    background-color: ${colors.light};
    border-radius: ${radius.small};
    padding: ${padding};
    min-height: ${height || 'auto'};
    align-items: ${horizontalAligment};
    justify-content: ${verticalAlignment};
    margin-bottom: ${spacing[marginBottom]};
    width: ${expanded ? '100%' : 'auto'};
  `}
`;

export const TitleWrapper = styled.div<
  Pick<TitleProps, 'marginBottom' | 'marginTop'>
>`
  ${({ marginBottom = 'none', marginTop = 'none' }) => css`
    display: flex;
    align-items: center;
    width: 100%;

    margin-top: ${spacing[marginTop]};
    margin-bottom: ${spacing[marginBottom]};
  `}
`;

export const TitleIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  margin-right: ${spacing.small};
`;

export const FooterWrapper = styled.div<
  Pick<FooterProps, 'alignItems' | 'hasDivider'>
>`
  ${({ alignItems = 'flex-end', hasDivider = false }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-top: ${hasDivider ? spacing.none : spacing.small};
    align-items: ${alignItems};
  `};
`;
